import { OrbitCamera } from './orbit-camera.js';
import { mod } from '../core/math.js';

class AutoOrbitCamera extends OrbitCamera {
    constructor() {
        super();
        this.isAutoRotating = false;
        this.autoRotateSpeed = 36; // 360度 / 10秒 = 36度/秒
        this.autoRotateDirection = 1; // 1为顺时针，-1为逆时针
    }

    startAutoRotate() {
        this.isAutoRotating = true;
    }

    stopAutoRotate() {
        this.isAutoRotating = false;
    }

    setAutoRotateSpeed(degreesPerSecond) {
        this.autoRotateSpeed = degreesPerSecond;
    }

    setAutoRotateDirection(direction) {
        this.autoRotateDirection = direction;
    }

    update(dt, input) {
        // 如果启用自动旋转，添加自动旋转输入
        if (this.isAutoRotating) {
            // 创建虚拟的旋转输入
            const autoInput = {
                move: { value: [0, 0, 0] },
                rotate: { value: [this.autoRotateSpeed * this.autoRotateDirection * dt, 0, 0] }
            };
            
            // 合并用户输入和自动旋转输入
            if (input) {
                autoInput.rotate.value[0] += input.rotate.value[0];
                autoInput.rotate.value[1] += input.rotate.value[1];
                autoInput.rotate.value[2] += input.rotate.value[2];
                autoInput.move.value[0] += input.move.value[0];
                autoInput.move.value[1] += input.move.value[1];
                autoInput.move.value[2] += input.move.value[2];
            }
            
            super.update(dt, autoInput);
        } else {
            super.update(dt, input);
        }
    }

    // 获取当前是否在自动旋转
    getAutoRotating() {
        return this.isAutoRotating;
    }
}

export { AutoOrbitCamera }; 